import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-61bf966c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "banner"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-wrap"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "智能出海，易起航行"), /*#__PURE__*/_createElementVNode("div", {
  class: "message"
}, "贸易新时代，用出海易掌握主动权")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    class: "banner-img",
    src: _ctx.DEFAULT_BANNER_IMG,
    alt: "banner-img",
    fit: "none"
  }, null, 8, _hoisted_2), _hoisted_3]);
}